module.exports = __webpack_public_path__ + "img/img-3.72c9a7db.jpg";